const BODY_LOCK_CLASS = 'lock';

export const lockBody = () => document.body.classList.add(BODY_LOCK_CLASS);

export const unlockBody = () => document.body.classList.remove(BODY_LOCK_CLASS);

export const focusElement = element => {
  element.focus();
  return element;
};

/**
 * Returns the first item of an array.
 *
 * head :: [a] -> a
 *
 * @param {Array} x the array to get the first item from.
 */
export const head = ([x]) => x;

/**
 * Returns all but the first item of an array.
 *
 * tail :: [a] -> [a]
 *
 * @param {Array} x the array to get all but the first item from.
 */
export const tail = ([, ...xs]) => xs;

/**
 * Returns the last element of an array or list
 * @param {Array} arrayOrString
 */
export const last = arrayOrString => {
  if (typeof arrayOrString === 'string')
    return arrayOrString[arrayOrString.length - 1] || '';

  return arrayOrString[arrayOrString.length - 1];
};

/**
 * Returns a reversed array. Uses the inbuilt Array.reverse for arrays and
 * split > reverse > join for strings.
 *
 * @param {Array} arrayOrString
 */
export const reverse = arrayOrString => {
  if (typeof arrayOrString === 'string')
    return arrayOrString
      .split('')
      .reverse()
      .join('');

  const clone = arrayOrString.concat();
  return clone.reverse();
};

/**
 * Composes functions together
 * @param  {...any} fns functions to compose
 * @returns {function}
 */
export const compose = (...fns) =>
  fns.reduce((f, g) => (...args) => f(g(...args)));

/**
 * Pipes functions together
 * @param  {...any} fns functions to pipe
 * @returns {function}
 */
export const pipe = (...fns) => x => fns.reduce((v, f) => f(v), x);

export const trace = label => value => {
  console.log(`${label}: ${value}`);
  return value;
};

export const addClass = className => element => {
  element.classList.add(className);
};

export const removeClass = className => element => {
  element.classList.remove(className);
};

export const toggleClass = (className, force = true) => element => {
  element.classList.toggle(className, force);
};

export const matcher = selector => event => event.target.matches(selector);

export const closer = selector => event => event.target.closest(selector);
